<template>
    <div class="module_assessment">

        <div v-if="isStudentLogin" :key="uuid">
            <div v-if="assessment.localPractice">
                <div class="max-attempt-row">
                    <span><span style="color: #949494;">This is the practice knowledge check.</span></span>
                </div>
                <div class="knowledge-row" style="margin-top: 22px;">
                    <b-button variant="primary" :to="{ name: 'assessmentLearnSR', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId} }" class="btn btn-lg">Start Quest</b-button>
                </div>
            </div>
            <div v-else>
              <div class="msg" v-if="courseCompetency && courseCompetency.status && courseCompetency.status === 1">
                  <span class="icon-warning"></span>
                  <span>We saved your Quest. You can continue Quest by clicking the "Resume" button.</span>
              </div>
              <div class="msg" v-if="courseCompetency && courseCompetency.status && courseCompetency.status > 1">
                  <span class="icon-warning"></span>
                  <span>Thank you for submitting the Quest. Your Coach will be in touch with you via message within one business day. Meanwhile, you can continue to work on the remaining Quests.</span>
              </div>
    			<div class="attempts_summary" v-if="myattempts.length > 0">
                  <!-- Show all attempts -->

    				<div class="section_head">Quest Submission Summary</div>
    				<table class="attempts_summary_table">
    					<tr>
    		          		<th>Date and Time <br/> of Submission</th>
    						<!--<th>Result</th>-->
    						<th>Report</th>
    		          	</tr>
                    	<tr v-for="(myattempt, index) in myattempts">
                    		<td>{{getFormattedDateTime(myattempt.startTime)}}</td>
                        <!--
                      		<td style="min-width: 100px">
    	                        <div v-if="!myattempt.manualGradingRequired || (myattempt.manualGradingRequired && myattempt.manuallyGraded)">
    	                        	<span class="icon_success" :id="'stat_' + index" :class="gradeStatus1('stat_' + index, myattempt.score, myattempt.maxScore)"></span> {{myattempt.score}} / {{myattempt.maxScore}}
    	                        </div>
                							<div v-else>
                								<span class="icon_success noGrade" :id="'stat_' + index"></span> {{myattempt.score}} / {{myattempt.maxScore}}
                							</div>
                          </td>
                        -->
                      		<td>
                      			<div v-if="myattempt.isResume && ((!myattempt.manualGradingRequired) || (myattempt.manualGradingRequired && myattempt.manuallyGraded))">
                                    <b-button variant="primary" :to="{ name: 'assessmentLearnSR', params: {uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId} }" class="btn sm-btn">Resume Quest</b-button>
                        		</div>
                        		<div v-else>
                        			<!--<b-button variant="primary" class="btn sm-btn" @click="showLearnosityReport(myattempt, myattempt.activityId, myattempt.sessionId)">Show Report</b-button>-->
                        			<b-button variant="primary" :to="{ name: 'assessmentLearnSR', params: {uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: myattempt.sessionId, canEdit: true} }" class="btn sm-btn">Edit Quest</b-button>
                        		</div>
                      		</td>
                    	</tr>
                  	</table>
    				<div v-if="isShowCheckKnowledgeButton" class="knowledge-row" style="margin-top: 22px;">
    					<b-button variant="primary" v-if="!assessment.isResume" :to="{ name: 'assessmentLearnSR', params: {uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId} }" class="btn btn-lg">Start Quest</b-button>
    				</div>
                </div>

                <div v-if="isShowCheckKnowledgeButton && myattempts.length === 0">
                  <div v-if="!assessment.isResume && isDescriptionReady" style="text-align: justify;">
                    <p v-if="assessment.description">{{assessment.description}}</p>
                    <p>Please click the button below to start this <i> quest</i></p>
                  </div>
                  <div>
                    <b-button variant="primary" size="lg" v-if="!assessment.isResume" :to="{ name: 'assessmentLearnSR', params: {uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId} }" class="btn_lg">Start Quest</b-button>
                    <b-button variant="primary" size="lg" v-else :to="{ name: 'assessmentLearnSR', params: { uuid: courseId, entityType: entityType, entityUuid: uuid, sessionId: assessment.sessionId} }" class="btn_lg">Resume Quest</b-button>
                  </div>
                </div>

                <b-modal ref="attemptReportInfo" size="lg" centered :title="knowledgeCheckReportTitle" @hidden="isShowAttemptReport = false" hide-footer class="learnosity-report-modal">
                    <template v-if="isShowAttemptReport">
                        <div slot="modal-header" class="header-section">
                            <div class="float-right">
                                <button type="button" aria-label="Close" class="attempt-report-close" @click="closeAttemptReport">x</button>
                            </div>
                        </div>
                        <div class="popup_inner_content">
                            <span class="learnosity-report" id="sessionDetailByItemReport"></span>
                        </div>
                    </template>
                </b-modal>

            </div>
        </div>

        <!-- Intructor View -->
        <div v-else>
            <div class="row page-heading border-0">
                <div class="col-8 input module_heading">
                    <span class="icon-assessment float-left"></span>
                    <span class="head_txt">{{ assessment.title }}</span>
                </div>
                <div class="col-4 submit btn-container text-right">
                    <button class="btn btn-primary" type="submit" @click="navigateToEdit" aria-label="edit">edit</button>
                    <button class="btn btn-primary" type="submit" @click="navigateToResult" aria-label="back">back</button>
                </div>
            </div>
            <div>
				<div class="row assessment-section mb-5">
					<div class="col-8 assessment-left-section">
						<div class="page-section">
							<div class="page_section_row input">
								<div class="heading border-0">
									<label for="description">Assessment Description</label>
								</div>
								<div class="description-text ml-3">{{ assessment.description }}</div>
							</div>
							<div class="page_section_row input mb-4 row">
								<div class="max-attempts col-6">
									<div class="heading border-0">
										<label for="maxAttempt">Maximum # of Attempts</label>
									</div>
									<div class="value">{{ assessment.maxAttempt }}</div>
								</div>

								<div class="max-attempts col-6">
                                    <div class="heading border-0">
                                        <label for="folder">Folder</label></div>
                                    <div class="value folder-name">{{ assessment.ancestorName }}</div>
                                </div>
							</div>
						</div>
					</div>

					<div class="page_section_row assessment-right-section col-4">
						<div class="heading">
							<span class="ic-tag general mr-2"></span>
							<span>Assessment Tags</span>
						</div>
						<div class="value" style="height: 102px;">
							<div class="tag-box-list" style="height: 102px;">
							  <div class="tags_container">
								<span class="tag" v-for="tag in assessmentTags">
									<span class="tag_name instructional_tag"> {{ tag.name }} </span>
								</span>
							  </div>
							</div>
						</div>
						<div class="mt-4"><input type="checkbox" id="checkbox" v-model="assessment.localPractice" disabled><span class="ml-2">Practice Test</span></div>
					</div>
				</div>
				<div class="mt-3">
					<div id="learnosity-author"></div>
				</div>
			</div>

			<div class="assessment-creation-popup confirmation-popup" v-if="isCreated">
                <b-modal ref="createSuccessModal" size="lg" :title="'1 assessment created'" :header-bg-variant="'create-asset-success-modal'" ok-disabled cancel-diasbled hide-header-close hide-footer no-close-on-backdrop no-close-on-esc centered>
                    <div class="content-row">
					<span class="label-column">
						Click if you have finished creating assessment
					</span>
					<span class="btn-column">
						<b-button @click="closeAndRedirect" class="btn button-primary"> ok </b-button>
					</span>
				</div>
				<div class="content-row">
					<span class="label-column">
						Click if you want to create more assessment
					</span>
					<span class="btn-column">
						<b-button @click="showCreate" class="btn button-primary" aria-label="continue creating assessment"> continue creating assessment </b-button>
					</span>
				</div>
                </b-modal>
            </div>

        </div>

    </div>
</template>

<script>
  /* global LearnosityItems LearnosityReports:true */
  import { mapState, mapActions } from 'vuex'
  import '../../../assets/module/less/create_entity.less'

  export default {
    name: 'assessmentDetail',
    props: ['uuid', 'courseId', 'isCreated', 'doNotShowOutcome'],

    data () {
      return {
        attempt: {},
        myattempts: [],
        assessment: {},
        courseCompetency: {},
        isDescriptionReady: false,
        isShowReportButton: false,
        isShowAttemptReport: false,
        isStudentLogin: (localStorage.getItem('userrole') === 'Student'),
        entityType: 'LearningContent',
        assessmentTags: [],
        status_css: {
          10: 'noGrade',
          0: 'gradeE',
          1: 'gradeD',
          2: 'gradeC',
          3: 'gradeB',
          4: 'gradeA'
        },
        reportsApp: {},
        scoringObjects: {},
        itemsAppTeacherScoring: {},
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      }
    },

    computed: {
      ...mapState({
        'course': state => state.course.course
      }),

      attemptsRemaining: function () {
        if (this.assessment && this.myattempts) {
          return this.assessment.maxAttempt - this.myattempts.length
        } else {
          return 0
        }
      },

      isShowCheckKnowledgeButton: function () {
        return this.isStudentLogin && this.assessment.isAttemptRemaining
      },

      showDescription: function () {
        if (this.course.courseType.startsWith('SUGGESTION')) {
          return true
        } else {
          return false
        }
      },

      isShowActivityOutcome: function () {
        if (this.doNotShowOutcome !== undefined) {
          return !this.doNotShowOutcome
        } else {
          const isAttempted = (this.attempt && this.attempt.maxScore)
          return (isAttempted !== undefined)
        }
        /*
        console.log('Path:', this.$router.app._route.name)
        if (this.$router.app._route.name === 'entityResult') {
          console.log('got in here')
          return true
        } else {
          return false
        } */
      },

      performance: function () {
        const score = this.courseCompetency.performance
        return (score) ? score.toFixed(2) : '0.00'
      },

      statusClass: function () {
        var status = 10
        var performance = 0
        if (this.courseCompetency) {
          performance = this.courseCompetency.performance
          if (performance !== null) {
            if (performance >= 90) {
              status = 4
              $('.header-view, .entity-title:after').addClass('gradeA')
            } else if (performance >= 80 && performance < 90) {
              status = 3
              $('.header-view, .entity-title:after').addClass('gradeB')
            } else if (performance >= 65 && performance < 80) {
              status = 2
              $('.header-view, .entity-title:after').addClass('gradeC')
            } else if (performance >= 40 && performance < 65) {
              status = 1
              $('.header-view, .entity-title:after').addClass('gradeD')
            } else if (performance < 40) {
              status = 0
              $('.header-view, .entity-title:after').addClass('gradeE')
            }
          } else {
            status = 10
            $('.header-view, .entity-title:after').addClass('noGrade')
          }
        }
        return this.status_css[status]
      }
    },

    watch: {
      uuid () {
        this.loadAssessmentDetail()
      }
    },

    mounted () {
      this.loadAssessmentDetail()
    },

    methods: {
      ...mapActions([
        'loadCourseCompetencies',
        'loadAssessment2',
        'showAttemptReport',
        'launchManuallyGradedReportWizardForUser'
      ]),

      getFormattedDateTime (timeInMillis, showOnlyDate) {
        if (timeInMillis === 0) {
          return 'N/A'
        }
        var d
        var str = ''
        d = new Date(timeInMillis)
        str += String(this.months[d.getMonth()])
        str += ' ' + d.getDate()
        str += ', ' + d.getFullYear()
        if (!showOnlyDate) {
          var amPm = ''
          var currHour = d.getHours()
          if (currHour < 12) {
            amPm = 'AM'
          } else {
            amPm = 'PM'
          }
          if (currHour === 0) {
            currHour = 12
          }
          if (currHour > 12) {
            currHour = currHour - 12
          }
          var currMin = d.getMinutes()
          currMin = currMin + ''
          if (currMin.length === 1) {
            currMin = '0' + currMin
          }
          var currSec = d.getSeconds()
          currSec = currSec + ''
          if (currSec.length === 1) {
            currSec = '0' + currSec
          }
          str += ' ' + currHour
          str += ':' + currMin
          str += ':' + currSec
          str += ' ' + amPm
        }
        return str
      },

      gradeStatus1 (entity, minscore, maxscore) {
        setTimeout(() => {
          var gradeClass = 'noGrade'
          var performance = parseFloat((minscore / maxscore) * 100).toFixed(2)
          if (performance >= 90) {
            gradeClass = 'gradeA'
          } else if (performance >= 80 && performance < 90) {
            gradeClass = 'gradeB'
          } else if (performance >= 65 && performance < 80) {
            gradeClass = 'gradeC'
          } else if (performance >= 40 && performance < 65) {
            gradeClass = 'gradeD'
          } else if (performance < 40) {
            gradeClass = 'gradeE'
          }
          $('#' + entity).addClass(gradeClass)
        }, 100)
      },

      loadAssessmentDetail () {
        if (this.courseId) {
          this.loadCourseCompetencies({courseId: this.courseId, loadDataFromServer: true}).then(res => {
            if (res && res.length > 0) {
              for (var i = 0; i < res.length; i++) {
                var competency = res[i]
                if (competency && (competency.entityId === this.uuid)) {
                  this.courseCompetency = competency
                  break
                }
              }
            }
            this.isDescriptionReady = true
          })
        }
        this.loadAssessment2({uuid: this.uuid}).then((response) => {
          const data = { ...response }
          this.myattempts = data.attempt
          if (this.myattempts && this.myattempts.length > 0) {
            this.attempt = this.myattempts[this.myattempts.length - 1]
          }
          this.assessment = data.assessment
          /*
          if (!(this.isShowCheckKnowledgeButton && this.assessment.isResume)) {
            this.isShowReportButton = true
          }
          */
          if (this.assessment.appliedTagMap) {
            this.assessmentTags = this.assessment.appliedTagMap.general
          }
          if (this.isCreated) {
            this.$refs.createSuccessModal.show()
          }
        })
      },

      closeAttemptReport () {
        this.$refs.attemptReportInfo.hide()
      },

      showLearnosityReport (myattempt, activityId, sessionId, isManuallyGraded) {
        this.attempt = myattempt
        this.isShowAttemptReport = true
        this.$refs.attemptReportInfo.show()
        this.showAttemptReport({activityId: activityId, sessionId: sessionId, courseId: this.courseId}).then(data => {
          if (data) {
            this.initializeLearnosityReports(data)
          }
        })
      },

      initializeLearnosityReports (data) {
        var self = this
        self.reportsApp = LearnosityReports.init(data, {
          'readyListener': function () {
            if (self.attempt.manuallyGraded) {
              self.bindReadyListener()
            }
          },
          'errorListener': function (event) {
            console.log('error: ', event)
          }
        })
      },

      bindReadyListener () {
        var itemReferences = []
        var report = this.reportsApp.getReport('sessionDetailByItemReport')
        report.on('ready:itemsApi', (itemsApp) => {
          itemsApp.getQuestions((questions) => {
            $.each(questions, (index, question) => {
              if ((question.metadata.valid_response_count === 0) && (question.metadata.rubric_reference !== undefined)) {
                var reference = question.metadata.rubric_reference
                var itemId = question.response_id + '_' + reference
                this.scoringObjects[itemId] = question
                itemReferences.push({'id': itemId, 'reference': reference})

                $('<span class="learnosity-item" data-reference="' + itemId + '">')
                  .appendTo($('#' + question.response_id).closest('.row')).wrap('<div class="teacher_scoring"></div>')
              }
            })
          })

          if (itemReferences.length > 0) {
            var itemsActivity = {
              'state': 'review',
              'type': 'feedback',
              'items': itemReferences,
              'rendering_type': 'inline',
              'session_id': this.attempt.sessionId,
              'activity_id': this.attempt.activityId
            }

            this.launchManuallyGradedReportWizardForUser(itemsActivity).then(data => {
              if (data) {
                var self = this
                self.itemsAppTeacherScoring = LearnosityItems.init(data, {
                  readyListener: function () {
                    self.generateScoreStimulus()
                  }
                })
              }
            })
          }
        })
      },

      generateScoreStimulus () {
        $.each(this.itemsAppTeacherScoring.getItems(), (index, item) => {
          const question = this.scoringObjects[index]
          const text = 'Enter score between 0-' + ((question.validation && question.validation.max_score) ? question.validation.max_score : 1)
          const elemId = 'stimulus-' + item.response_ids[0]
          $('#' + elemId).text(text)
        })
      },

      navigateToEdit () {
        return this.$router.push({ name: 'editAssessment', params: { uuid: this.assessment.uuid } })
      },

      navigateToResult () {
        return this.$router.push({ name: 'results' })
      },

      closeAndRedirect () {
        this.$refs.createSuccessModal.hide()
        return this.$router.push({ name: 'results' })
      },

      showCreate () {
        this.$refs.createSuccessModal.hide()
        return this.$router.push({ name: 'createAssessment' })
      }
    }
  }
</script>

<style scoped>


.score {
    float: left;
    font-size: 23px;
    margin-top: 0px;
}
.score_txt {
    display: inline-block;
    margin-top: 8px;
    margin-left: 8px;
}
.answered {
    float: right;
}
.score_txt, .answered {
	color: rgb(148, 148, 148);
}

.submit button[disabled],
.submit button[disabled]:hover,
.submit button[disabled]:active {
    border: 1px solid #ccc;
    background-color: transparent;
    color: #ccc;
    cursor: not-allowed;
}
.right-panel {
    overflow-y: auto;
    height: calc(100vh - 240px);
}
.icon_state, .icon_state:before {
    width:25px;
    height:25px;
}
.ic_status {
    margin-top: 8px;
    margin-right: 10px;
    float: left;
}
.toc_result_summary {
	margin-bottom: 20px;
}

.tag-box-list {
	margin-top: 5px;
    float: left;
	border-top:1px solid #e6e6e6;
  }

  .tag-box-content {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px;
    float: left;
  }

  .page_content_block {
	max-height: 122px;
    overflow-y: auto;
  }

  .assessment-creation-popup .continue {
	margin-left:38px;
  }

  .result_summary {
  	float: left;
	width:100%;
  }

  .msg {
  	float: left;
    width: 100%;
    margin-top: 20px;
    text-align: justify;
  }
  .icon-warning {
 	font-size: 22px;
 	color: #ab9e00;
  }
  .knowledge-row {
	margin-top:10px;
	width:100%;
	text-align:right;
  }

  button.attempt-report-close {
    border: 0;
    background: transparent;
    padding: 15px;
    margin: -15px -15px -15px auto;
    cursor: pointer;
    -webkit-appearance: none;
  }

  .attempt-report-close {
    float: right;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
  }

  .additional-btn {
	margin-top: 30px;
  }


</style>



// WEBPACK FOOTER //
// src/app/assessment/components/AssessmentDetailSR.vue